var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-wrapper h-screen ml-56"},[_c('div',{staticClass:"w-full h-full overflow-y-scroll bg-truegray-100"},[(_vm.postId)?_c('CWPost',{attrs:{"post_id":_vm.postId,"edit":_vm.edit,"page":_vm.page}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }